import { render } from "./testmethodquestionsordereditor.vue?vue&type=template&id=7ad89dd2"
import script from "./testmethodquestionsordereditor.vue?vue&type=script&lang=js"
export * from "./testmethodquestionsordereditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__